import script from "./Seal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Seal.vue?vue&type=script&setup=true&lang=ts"

import "./Seal.vue?vue&type=style&index=0&id=072524ee&scoped=true&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-072524ee"]])

export default __exports__